import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EstimatesAndInvoicesComponent } from './estimates-and-invoices.component';
import { InvoiceModule } from '../invoice/invoice.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, InvoiceModule, TranslateModule],
  exports: [EstimatesAndInvoicesComponent],
  declarations: [EstimatesAndInvoicesComponent],
})
export class EstimatesAndInvoicesModule {}
